import React, { Component } from 'react';
import { MyInput } from '../elements/MyInput';
import { Table } from 'reactstrap';
import { WinnerBox } from '../elements/WinnerBox'
import { WinnerTable } from '../tables/winner/WinnerTable';
import { GhoreFirstPage } from './GhoreFirstPage';
import { GhoreSecondPage } from './GhoreSecondPage';
export class GhoreOperation extends Component {
    static displayName = GhoreOperation.name;


    constructor(props) {
        super(props);
        this.state = {};
        this.state.data = {};


        this.state.data.lotteryType = 1;
        this.state.data["count"] = 1;

        this.state.reverseChances = [];
        this.state.reverseNum = "";


        this.sendingGhore = false;

        this.startClick = this.startClick.bind(this);


        this.handleTextChange = this.handleTextChange.bind(this);

        this.onCloseWinnerBox = this.onCloseWinnerBox.bind(this);

        this.reverseNumberChange = this.reverseNumberChange.bind(this);

        this.sendGhore = this.sendGhore.bind(this);
        var token = localStorage.getItem('token');
        this.headers =
        {
            'Content-Type': 'application/json',
            'AuthorizationToken': token
        };

    }

    reverseNumberChange(e) {


        this.state.reverseNum = e;
        this.setState({});
        var d = {
            ceremonyId: this.props.ceremonyId,
            reverseNum: e
        }

        fetch('api/v1/GetReverseChance',
            {
                method: 'POST',
                body: JSON.stringify(d),
                headers: this.headers
            }).then(res => {
                this.status = res.status;


                if (this.status === 401) {
                    localStorage.setItem('token', null);
                    window.location.reload(false);

                }

                res.json().then((result) => {

                    //      console.log("status:" + this.status);

                    if (this.status === 200) {

                        //   console.log(result);
                        //  this.state.reverseChances = result;

                        this.state.isLoaded = true;
                        this.setState({ reverseChances: result });

                        //    console.log(this.state.reverseChances);

                    }
                    else {
                        // alert(result.Value);
                        //    this.setState({});
                        //window.location.href = "/ghorekeshi";
                    }

                },
                    (error) => {

                    }
                );
            }
            );
    }

    handleTextChange(data, key) {
        this.state.data[key] = data;
    }
    sendGhore() {
        //  console.log(this.state.data);

        if (this.sendingGhore === true)
            return;

        this.sendingGhore = true;
        fetch('api/v1/ExecuteGhoreKeshi',
            {
                method: 'POST',
                body: JSON.stringify(this.state.data),
                headers: this.headers
            }).then(res => {
                this.status = res.status;


                if (this.status === 401) {
                    localStorage.setItem('token', null);
                    window.location.reload(false);

                }

                res.json().then((result) => {

                    //    console.log("status:" + this.status);


                    if (this.status === 200) 
                    {
                        this.sendingGhore = false;
                        this.state.winner = result[0];
                        //          console.log(result);

                        this.state.showWinner = true;

                        this.state.prize.remain--;


                        this.setState({});

                    }
                    else {

                        this.sendingGhore = false;
                        alert(result.Value);
                        this.setState({});
                        //window.location.href = "/ghorekeshi";
                    }

                },
                    (error) => {
                        this.sendingGhore = false;

                    }
                );
            }
            );

    }
    startClick() {
        this.state.showFirstPage = false;
        this.setState({});
    }

    componentDidMount() {
        this.setState({ isLoaded: false });

        var data =
        {
            ceremonyId: this.props.ceremonyId

        };
        this.headers["ceremonyId"] = this.props.ceremonyId;


        fetch('api/v1/GetCeremonyState',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: this.headers
            }).then(res => {
                this.status = res.status;


                if (this.status === 401) {
                    localStorage.setItem('token', null);
                    window.location.reload(false);

                }

                res.json().then((result) => {

                    //         console.log("status:" + this.status);

                    if (this.status === 200) {

                        this.state.ceremony = result;

                        //            console.log(result);
                        this.setState({ isLoaded: true });

                    }
                    else {
                        alert(result.Value);
                        window.location.href = "/ghorekeshi";
                    }

                },
                    (error) => {

                    }
                );
            }
            );

    }

    onCloseWinnerBox() {
        this.state.showWinner = false;
        this.setState({});
    }







    render() {

        if (!this.state.isLoaded) {
            return <div> ... </div>;
        }





        if (this.state.showWinner) {
            return <WinnerBox winner={this.state.winner} prize={this.state.prize} onCloseWinnerBox={this.onCloseWinnerBox} />
        }
        else {

            this.state.prize = null;
            for (var i = 0; i < this.state.ceremony.ceremonyGhorePrizes.length; i++) {
                var x = this.state.ceremony.ceremonyGhorePrizes[i];
                if (x.remain > 0) {
                    this.state.prize = x;
                    break;
                }
            }

            if (this.state.prize == null) {
                return <WinnerTable ceremonyId={this.props.ceremonyId} showMask={true} />;
            }

            this.state.data.ghorePrizeId = this.state.prize.ghorePrizeId;


            if (this.state.data.preGhorePrizeId != this.state.data.ghorePrizeId) {
                this.state.showFirstPage = true;
            }

            this.state.data.preGhorePrizeId = this.state.data.ghorePrizeId;

            if (this.state.showFirstPage == true) {

                return <GhoreFirstPage prize={this.state.prize} reverseNum={this.state.reverseNum} max={this.state.ceremony.max} onStartClick={this.startClick} />

            }
        }



        return (
            <GhoreSecondPage prize={this.state.prize} reverseNum={this.state.reverseNum} reverseChances={this.state.reverseChances} max={this.state.ceremony.max} ceremonyId={this.props.ceremonyId} handleTextChange={this.handleTextChange} reverseNumberChange={this.reverseNumberChange} sendGhore={this.sendGhore} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/GhoreOperation.js